<svelte:head>
    <link rel='stylesheet' href='/global.css' />
</svelte:head>

<script>

    import {
        loginUser,
        sessionCheck,
        getResetCode,
        saveResetPassword
    } from "../api.svelte"
    import {getContext, onMount} from "svelte";
    import { fade } from 'svelte/transition';

    let email;
    let password;

    let code;

    let currentOverlay = 'none'

    let formError = false;
    let isLoading = false;
    let errorResetTimer = null;

    export const ERROR_DISAPPEAR_AFTER = 5500;

    const router = getContext('router');

    export const errorReasons = {
        'not_found': 'Account existiert nicht',
        'inactive': 'Bitte kontaktieren Sie unseren Support',
        'not_native': 'TODO',
        'password_incorrect': 'Falsches Passwort',
        'ratelimit': 'Bitte versuchen Sie es später nochmals',
        'fill_fields': 'Bitte füllen Sie alle Felder aus',
        'invalid_email': 'Bitte überprüfen Sie Ihre E-Mail-Adresse',
        'missing_params': 'Unerwarteter Fehler aufgetreten',
        'email_exists': 'Account mit dieser E-Mail-Adresse existiert bereits',
        'password_length': 'Mindestlänge Passwort sind 8 Zeichen',
        'unexpected_error_plans': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später nochmals.',
        'no_available': 'Sie können keine weiteren Locations registrieren',
        'no_integrations': 'Bitte verlinken Sie mindestens ein Portal',
        'max_integrations': 'Sie haben Ihre maximale Anzahl an verlinkten Portalen erreicht'
    };


    onMount(() => {

        checkLocalSession();
    })

    const getStoredSession = () => {

        return localStorage.getItem('sid');
    };

    let checkLocalSession = async () => {

        let storedSession = getStoredSession();

        if (storedSession) {

            sessionCheck().then((sessionVerified) => {

                if (sessionVerified) {

                    router.route('/');

                }

            });

        }

    };

    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            formError = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let loginHandler = () => {

        if (isLoading) return;

        if (email === '' || password === '') {

            formError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        isLoading = true;

        email = email.replaceAll(' ', '').toLowerCase();

        loginUser(email, password).then((loginResult) => {

            isLoading = false;

            if (loginResult['status'] !== 'success') {

                console.log(loginResult)
                formError = loginResult['reason'];
                startErrorResetTimer();

                return;

            }

            localStorage.setItem('sid', loginResult['sessionid'])
            localStorage.setItem('userstatus', loginResult['userstatus'])

            isLoading = false;
            router.route('/');

        });

    };

    let getCodeHandler = () => {

        if (isLoading) return;

        password = '';

        if (email === '') {

            formError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        isLoading = true;

        email = email.replaceAll(' ', '').toLowerCase();

        getResetCode(email).then((resetResult) => {

            if (resetResult['status'] !== 'success') {

                console.log(resetResult)
                formError = resetResult['reason'];
                startErrorResetTimer();

                return currentOverlay = 'reset';

            }

            isLoading = false;

            currentOverlay = 'code'

        });

    }

    let handleSaveReset = () => {

        console.log('in handle save')

        if (isLoading) return;

        if (code === '' || password === '') {

            formError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        isLoading = true;

        saveResetPassword(code, password, email).then((resetResult) => {

            if (resetResult['status'] !== 'success') {

                console.log(resetResult)
                formError = resetResult['reason'];
                startErrorResetTimer();

                isLoading = false;

                return;

            }

            isLoading = false;

            currentOverlay = 'none';

        });

    }

</script>

<div id="login-container">


    <div class="assistant-container details-container">

        <div class="logo-container">
            <img src="images/logo.png" alt="">
        </div>

        {#if currentOverlay === 'none'}

            <form on:submit|preventDefault={() => loginHandler()}>

                {#if formError}

                    <div transition:fade id="error">

                        {errorReasons[formError]}

                    </div>

                {/if}

                <input
                        bind:value={email}
                        type="email"
                        placeholder="E-Mail"
                        name="email"
                        required />

                <input
                        bind:value={password}
                        name="password"
                        placeholder="Passwort"
                        type="password">

                <button class={(isLoading) ? 'loading btn' : 'btn'}>
                    <span>Login</span>
                    <img src="images/loader/button-loader.svg" alt="">
                </button>

            </form>

            <div class="reset-link">

                <span on:click={() => currentOverlay = 'reset'}>Passwort vergessen?</span>

            </div>

        {/if}

        {#if currentOverlay === 'reset'}

            <form on:submit|preventDefault={() => getCodeHandler()}>

                {#if formError}

                    <div transition:fade class="error">

                        {errorReasons[formError]}

                    </div>

                {/if}

                <input
                        bind:value={email}
                        name="email"
                        placeholder="Email"
                        type="email">

                <button class={(isLoading) ? 'loading btn' : 'btn'}>
                    <span>Code per Email senden</span>
                    <img src="images/loader/button-loader.svg" alt="">
                </button>

            </form>

        {/if}

        {#if currentOverlay === 'code'}

            <form on:submit|preventDefault={() => handleSaveReset()}>

                {#if formError}

                    <div transition:fade class="error">

                        {errorReasons[formError]}

                    </div>

                {/if}

                <input
                        bind:value={code}
                        name="code"
                        placeholder="Code"
                        type="text">

                <input
                        bind:value={password}
                        name="passwort"
                        placeholder="Neues Passwort"
                        type="password">

                <button class={(isLoading) ? 'loading btn' : 'btn'}>
                    <span>Neues Passwort speichern</span>
                    <img src="images/loader/button-loader.svg" alt="">
                </button>

            </form>

        {/if}
    </div>

</div>

<style>

    #login-container {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100vw;
        height: 100vh;
        justify-content: center;
        align-items: center;
    }

    #login-container .assistant-container {
        margin-bottom: 0;
    }

    #login-container .logo-container {
        height: 12vh;
    }

    #login-container .logo-container img {
        height: 100%;
    }

    form {
        display: flex;
        flex-direction: column;
        margin-top: 4vh;
    }

    span {
        font-family: 'Urbanist', sans-serif;
    }

    .reset-link {
        display: flex;
        justify-content: center;
    }

    .error {
        color: red;
        font-family: 'Urbanist', sans-serif;
        font-size: 1.6vh;
    }



</style>